/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "complaints-widget-spinner"
};
const _hoisted_2 = {
    key: 1,
    class: "complaints-widget-error"
};
const _hoisted_3 = {
    key: 2,
    class: "complaints-widget-main"
};
const _hoisted_4 = { class: "complaints-widget-main__content" };
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 0,
    class: "complaints-widget-main__pincode"
};
const _hoisted_7 = { class: "complaints-widget-main__pincode--bold" };
const _hoisted_8 = {
    key: 1,
    class: "complaints-widget-main__text"
};
const _hoisted_9 = { class: "complaints-widget-main__code" };
const _hoisted_10 = { class: "complaints-widget-main__description" };
const _hoisted_11 = ["href"];
import { api } from '@/api/api';
import AppTimer from '@/components/Generic/AppTimer/AppTimer.vue';
import { useVisibilityCycle } from '@/composables/useVisibilityCycle';
import { countryMasksExtended } from '@/constants/common';
import { formatPhoneNumber } from '@/utils/common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ComplaintsWidgetMain',
    props: {
        country: {}
    },
    emits: ["success"],
    setup(__props, { emit: __emit }) {
        /* eslint-disable @intlify/vue-i18n/no-missing-keys */
        const emit = __emit;
        const { t } = useI18n();
        const phoneDstData = reactive({
            phone: '',
            pincode: '',
            expires_at: 0,
            session: '',
        });
        const isLoading = ref(false);
        const errorText = ref('');
        const endTime = ref(null);
        const remainingMs = ref(0);
        const formatedPhone = computed(() => {
            return phoneDstData.phone ? formatPhoneNumber(phoneDstData.phone, countryMasksExtended[__props.country]) : '';
        });
        const link = computed(() => {
            switch (__props.country) {
                case 'UA':
                    return 'https://zvonok.com/uk-ua/documents/policy/';
                case 'RU':
                    return 'https://zvonok.com/ru-ru/documents/policy-ct/';
                case 'KZ':
                    // Объединяем кейсы, так как результат одинаковый
                    return 'https://zvonok.com/ru-kz/documents/policy-ct/';
                default:
                    // Все остальные страны (fallback)
                    return 'https://zvonok.com/ru-kz/documents/policy/';
            }
        });
        const checkCallStatus = async () => {
            try {
                const sessionId = localStorage.getItem('sessionid') || '';
                if (!sessionId) {
                    errorText.value = t('please_try_again_or_contact_support');
                    return;
                }
                const res = await api.complaints.checkStatus(__props.country, sessionId);
                if (res?.data?.data?.phone) {
                    stopCycle();
                    emit('success', res.data.data.phone);
                }
            }
            catch (e) {
                console.error(e);
            }
        };
        const { start: startCycle, stop: stopCycle } = useVisibilityCycle(checkCallStatus, 5000, {
            delayBeforeStartMs: 1000,
            runImmediatelyOnStart: false,
        });
        const handleExpired = async () => {
            stopCycle();
            await getPhoneDst();
        };
        const getPhoneDst = async () => {
            isLoading.value = true;
            errorText.value = '';
            try {
                const sessionId = localStorage.getItem('sessionid') || '';
                const res = await api.complaints.getPhoneDst(__props.country, sessionId);
                Object.assign(phoneDstData, res.data.data);
                if (phoneDstData.session) {
                    localStorage.setItem('sessionid', phoneDstData.session);
                }
                endTime.value = phoneDstData.expires_at;
                const now = Date.now();
                remainingMs.value = Math.max(endTime.value - now, 0);
                startCycle();
            }
            catch (e) {
                errorText.value = t('please_try_again_or_contact_support');
                console.error(e);
            }
            finally {
                isLoading.value = false;
            }
        };
        watch(() => __props.country, () => {
            stopCycle();
            getPhoneDst();
        }, { immediate: true });
        onUnmounted(() => {
            stopCycle();
        });
        return (_ctx, _cache) => {
            const _component_qr_code = _resolveComponent("qr-code");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createCommentVNode(" eslint-disable @intlify/vue-i18n/no-missing-keys "),
                (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("svg", {
                                width: "60",
                                height: "60",
                                viewBox: "0 0 60 60",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                            }, [
                                _createElementVNode("circle", {
                                    opacity: "0.2",
                                    cx: "29.8135",
                                    cy: "30.0729",
                                    r: "24.4536",
                                    stroke: "#FF7545",
                                    "stroke-width": "10.5745"
                                }),
                                _createElementVNode("path", {
                                    d: "M28.2604 5.60742C39.4132 5.60742 54.2836 11.8034 54.2836 31.6307",
                                    stroke: "#FF7545",
                                    "stroke-width": "10.5745",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                })
                            ], -1 /* CACHED */)
                        ]))]))
                    : (_unref(errorText))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(errorText)), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("a", {
                                    href: `tel:${_unref(formatedPhone)}`,
                                    class: "complaints-widget-main__phone"
                                }, _toDisplayString(_unref(formatedPhone)), 9 /* TEXT, PROPS */, _hoisted_5),
                                (_unref(phoneDstData).pincode)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createTextVNode(_toDisplayString(_unref(t)('and_enter_the_code')) + ": ", 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(phoneDstData).pincode), 1 /* TEXT */)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (_unref(remainingMs) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createTextVNode(_toDisplayString(_unref(phoneDstData).pincode ? _unref(t)('code_will_change') : _unref(t)('number_will_change')) + " ", 1 /* TEXT */),
                                        _createVNode(AppTimer, {
                                            milliseconds: _unref(remainingMs),
                                            "onUpdate:milliseconds": _cache[0] || (_cache[0] = ($event) => (_isRef(remainingMs) ? (remainingMs).value = $event : null)),
                                            onHasExpired: handleExpired
                                        }, null, 8 /* PROPS */, ["milliseconds"])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_qr_code, {
                                    value: `tel:${_unref(formatedPhone)}`,
                                    size: 175,
                                    margin: 1
                                }, null, 8 /* PROPS */, ["value"]),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('point_phone_number')), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('we_identify_your_phone_number')), 1 /* TEXT */),
                                _createElementVNode("a", {
                                    href: _unref(link),
                                    target: "_blank"
                                }, _toDisplayString(_unref(t)('personal_data_processing_policy')), 9 /* TEXT, PROPS */, _hoisted_11)
                            ])
                        ]))
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
